export default "__VITE_ASSET__bRfcmWPn__"